import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { SidebarProvider } from "./components/ContextAPI/SidebarContext";
import "./App.css";
import Index from "./components/Routes";
import AppLogout from "./components/AutoLogout/AutoLogout";
import { ProfileProvider } from "./components/ContextAPI/ProfileContext";
import { SidebarDeskProvider } from "./components/ContextAPI/SidebarContextDesktop";

function App() {
  return (
    <AppLogout>
      <SidebarDeskProvider>
        <SidebarProvider>
          <ProfileProvider>
            <Router>
              <div className="App">
                <Index />
              </div>
            </Router>
          </ProfileProvider>
        </SidebarProvider>
      </SidebarDeskProvider>
    </AppLogout>
  );
}

export default App;
